export default class HeroVideo {
    constructor() {
        const wrapper = document.getElementById('hero-video');
        if (!wrapper) {
            return;
        }

        this.wrapper = wrapper;


        this.current = '';

        window.addEventListener('resize', () => {
            this.setVideo();
        });

        this.setVideo();
    }

    setVideo() {
        // if aspect ratio is > 4:3
        if (window.innerWidth / window.innerHeight > 4 / 3) {
            if (this.current !== 'desktop') {
                this.current = 'desktop';
                this.wrapper.innerHTML = `<video preload="metadata" autoplay playsinline muted loop>
                    <source src="/videos/hero--desktop-2024-1080p.mp4?version=1" type="video/mp4" media="(min-width: 1281px)">
                    <source src="/videos/hero--desktop-2024-720p.mp4?version=1" type="video/mp4" media="(max-width: 1280px)">
                    <source src="/videos/hero--desktop-2024.webm?version=1" type="video/webm">
                </video>`
            }
        } else {
            if (this.current !== 'mobile') {
                this.current = 'mobile';
                this.wrapper.innerHTML = `<video preload="metadata" autoplay playsinline muted loop>
                    <source src="/videos/hero--mobile-2024-1080p.mp4?version=1" type="video/mp4" media="(min-width: 1281px)">
                    <source src="/videos/hero--mobile-2024-720p.mp4?version=1" type="video/mp4" media="(max-width: 1280px)">
                    <source src="/videos/hero--mobile-2024.webm?version=1" type="video/webm">
                </video>`
            }
        }
    }
}
